import ApiUtil from '../util/ApiUtil';
import Constants from '../constants/Constants';
import {IAccessPhrase} from '../model/accessPhraseModel';

const accessPhraseBaseUrl = '/api/v1/accessphrase';

const generateAccessPhrase = async () => {
   const response = await ApiUtil.executePostAsync<IAccessPhrase>(accessPhraseBaseUrl, [Constants.statusCodes.ok]);
   return response.data.accessPhrase;
};

export default {
   generateAccessPhrase
};
